"use client";
import * as React from "react";
const SvgTaskFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8.625 0h-6.5A1.61 1.61 0 0 0 .508 1.6L.5 14.4c0 .88.723 1.6 1.617 1.6h9.758c.894 0 1.625-.72 1.625-1.6V4.8L8.625 0ZM6.139 12.8 3.262 9.968 4.409 8.84l1.723 1.696 3.445-3.392 1.145 1.128L6.14 12.8Zm1.673-7.2V1.2l4.47 4.4h-4.47Z" }));
export {
  SvgTaskFilled as default
};
